import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const IpadIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "IpadIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.3909 2.38373H7.22709C5.96882 2.38863 4.9426 3.41625 4.93945 4.67487V19.8659C4.9426 21.1238 5.96882 22.1514 7.22709 22.1563H18.8291C19.3219 22.1563 19.8028 21.9547 20.1493 21.6026C20.4955 21.2505 20.6887 20.7647 20.6799 20.2754V4.67418C20.6764 3.41626 19.6499 2.38863 18.3909 2.38373ZM19.4682 20.2985C19.4731 20.4644 19.4094 20.6282 19.2918 20.7486C19.1714 20.8739 19.0017 20.946 18.8267 20.9467H7.22954C6.63523 20.9439 6.15082 20.4581 6.14907 19.8652V4.67558C6.15082 4.08197 6.63523 3.59616 7.22814 3.59336H18.3895C18.9835 3.59616 19.4682 4.08197 19.4703 4.67488V20.2439L19.4672 20.2551L19.4682 20.2985Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0365 4.52728H7.54123C7.26752 4.52728 7.04492 4.74988 7.04492 5.02289V18.1327C7.04492 18.4058 7.26752 18.6284 7.54123 18.6284H18.0365C18.3099 18.6284 18.5325 18.4058 18.5325 18.1327V5.02289C18.5325 4.74988 18.3099 4.52728 18.0365 4.52728ZM17.5801 5.5192V17.5972H8.03719V5.5192H17.5801Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.3373 19.3935H12.283C11.9495 19.3935 11.6782 19.6651 11.6782 19.9983C11.6782 20.3315 11.9495 20.6031 12.283 20.6031H13.3373C13.6708 20.6031 13.9421 20.3315 13.9421 19.9983C13.9421 19.6651 13.6708 19.3935 13.3373 19.3935Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default IpadIcon;
